/**
 * The Forgejo web UI behind the file store facade — the "advanced" browse
 * surface (full git history, diffs, blame). The facade mirrors this base in
 * its own web_url decorations (FORGEJO_PUBLIC_URL), so links built here match
 * what the API would hand out. Sign-in is required (closed instance).
 */
export const FILESTORE_FORGEJO_WEB_URL: string =
  import.meta.env.VITE_FILESTORE_FORGEJO_URL ?? 'http://localhost:13000';

/** Forgejo organization name for a Capitol org, per the facade's mapping. */
export const forgejoOrgName = (orgId: string): string =>
  `org-${orgId.toLowerCase()}`;

export const forgejoRepoUrl = (orgId: string, repo: string): string =>
  `${FILESTORE_FORGEJO_WEB_URL}/${forgejoOrgName(orgId)}/${encodeURIComponent(repo)}`;

export const forgejoTreeUrl = (
  orgId: string,
  repo: string,
  ref: string,
  dirPath: string,
): string => {
  const base = forgejoRepoUrl(orgId, repo);
  if (!dirPath) return base;
  const encodedPath = dirPath.split('/').map(encodeURIComponent).join('/');
  return `${base}/src/branch/${encodeURIComponent(ref)}/${encodedPath}`;
};
